import { injectable } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import type { Props as JoyRideProps, Step } from 'react-joyride';

@injectable()
export class LearningGuideStore {
  @observable
  private _joyRideProps: Omit<JoyRideProps, 'steps'> = {};

  @observable
  private _steps: Array<Step> = [];

  public constructor() {
    makeObservable(this);
  }

  public get joyRideProps(): Omit<JoyRideProps, 'steps'> {
    return this._joyRideProps;
  }

  public get steps(): Array<Step> {
    return this._steps;
  }

  @action
  public setJoyRideProps(joyRideProps: Omit<JoyRideProps, 'steps'>): void {
    this._joyRideProps = joyRideProps;
  }

  @action
  public setSteps(steps: Array<Step>): void {
    this._steps = steps;
  }
}
